import { Icon } from './Layout'

export function MaintenanceNotice({
  title = 'Under Maintenance',
  message = "This feature is temporarily unavailable. We're working on it — check back soon.",
  fullScreen = false,
}) {
  const content = (
    <div
      className="border-4 border-on-background bg-surface-container p-8 lg:p-12 flex flex-col items-center text-center gap-4 max-w-md mx-auto"
      style={{ boxShadow: '5px 5px 0px 0px var(--neo-shadow-color)' }}
    >
      <div className="w-14 h-14 border-[3px] border-on-background bg-primary-container flex items-center justify-center">
        <Icon name="construction" className="text-[28px] text-on-primary-container" />
      </div>
      <h1 className="font-extrabold text-[18px] uppercase tracking-widest text-on-surface">{title}</h1>
      <p className="text-[13px] text-on-surface-variant">{message}</p>
    </div>
  )

  if (!fullScreen) {
    return (
      <div className="flex-1 lg:ml-[300px] w-full max-w-4xl flex items-center justify-center px-4 pt-16 pb-24 md:pb-8">
        {content}
      </div>
    )
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background px-4">
      {content}
    </div>
  )
}